module.exports = __webpack_public_path__ + "static/media/youtube.91b89dc5.svg";